export type DataType =
  | "ID"
  | "Text"
  | "Boolean"
  | "Number"
  | "State"
  | "Date"
  | "Duration"
  | "Tag"
  | "User"
  | "Account"
  | "Classification";

const fieldList = [
  {
    fieldName: "id",
    dataType: "ID",
    isSortable: true,
    isSearchable: true,
  },
  {
    fieldName: "fullName",
    dataType: "Text",
    isSortable: true,
    isSearchable: true,
  },
  {
    fieldName: "creator",
    dataType: "User",
    isSortable: false,
    isSearchable: true,
  },
  {
    fieldName: "account",
    dataType: "Account",
    isSortable: false,
    isSearchable: false,
  },
  {
    fieldName: "created",
    dataType: "Date",
    isSortable: true,
    isSearchable: true,
  },
  {
    fieldName: "classification",
    dataType: "Classification",
    isSortable: true,
    isSearchable: true,
  },
] as const;

export type FieldName = (typeof fieldList)[number]["fieldName"];

export type Fields = {
  [FieldName in (typeof fieldList)[number]["fieldName"]]: Extract<
    (typeof fieldList)[number],
    { fieldName: FieldName }
  >;
};

export type Field = Fields[keyof Fields];

export type ResourceField<ResourceType extends object> = {
  fieldName: keyof ResourceType;
} & Field;

export type FieldLabels<ResourceType extends object> = {
  [FieldName in keyof ResourceType &
    (typeof fieldList)[number]["fieldName"]]: string;
};

const _fields = {} as Record<keyof Fields, Field>;
for (const field of fieldList) {
  _fields[field.fieldName] = field;
}
export const fields = _fields as Fields;

export function isKnownField(fieldName: string): fieldName is keyof Fields {
  return fieldName in fields;
}

export const defaultFieldLabels = {
  id: "ID",
  fullName: "Name",
  creator: "Submitted by",
  account: "Account",
  created: "Created",
  classification: "Classification",
} as const;

export function getDefaultSortOrder(field: Field): "asc" | "desc" {
  switch (field.dataType) {
    case "Date":
      return "desc";
    default:
      return "asc";
  }
}
